import { enUS, pl } from 'date-fns/locale';
import { format } from 'date-fns';
import { AppLanguage } from '../types/language.types';
import i18n from '../i18n';

const getLanguageFormatCode = (language: string) => {
  switch (language) {
    case 'en':
      return 'en-US';
    default:
      return 'pl-PL';
  }
};

export const formatDate = (date: Date, language: string, options?: Intl.DateTimeFormatOptions) => {
  const langCode = getLanguageFormatCode(language);

  return date.toLocaleDateString(
    langCode,
    options || {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    },
  );
};

export const formatTime = (date: Date, language: string, options?: Intl.DateTimeFormatOptions) => {
  const langCode = getLanguageFormatCode(language);

  return date.toLocaleTimeString(
    langCode,
    options || {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    },
  );
};

export const getLocaleByLanguage = () => {
  switch (i18n.language) {
    case AppLanguage.PL:
      return pl;
    default:
      return enUS;
  }
};

export const convertDateToString = (date: number, dateFormat: string): string =>
  format(date, dateFormat, {
    locale: getLocaleByLanguage(),
  });

export const convertDateToFormat = (date: Date, dateFormat: string): string =>
  format(date, dateFormat, {
    locale: getLocaleByLanguage(),
  });
